import {createAction, props} from '@ngrx/store';
import {BackgroundTask} from './background-task.model';

export const loadPendingTasks = createAction(
  '[BackgroundTask] Load Pending Tasks'
);

export const loadPendingTasksSuccess = createAction(
  '[BackgroundTask] Load Pending Tasks Success',
  props<{ tasks: BackgroundTask[] }>()
);

export const loadPendingTasksFailure = createAction(
  '[BackgroundTask] Load Pending Tasks Failure',
  props<{ error: Error }>()
);

export const loadTasks = createAction(
  '[BackgroundTask] Load Tasks',
  props<{ limit?: number }>()
);

export const loadTasksSuccess = createAction(
  '[BackgroundTask] Load Tasks Success',
  props<{ tasks: BackgroundTask[] }>()
);

export const loadTasksFailure = createAction(
  '[BackgroundTask] Load Tasks Failure',
  props<{ error: Error }>()
);

export const taskCompleted = createAction(
  '[BackgroundTask] Task Completed',
  props<{ task: BackgroundTask }>()
);

export const clearCompletedNotification = createAction(
  '[BackgroundTask] Clear Completed Notification',
  props<{ taskId: number }>()
);

export const BackgroundTaskActions = {
  loadPendingTasks,
  loadPendingTasksSuccess,
  loadPendingTasksFailure,
  loadTasks,
  loadTasksSuccess,
  loadTasksFailure,
  taskCompleted,
  clearCompletedNotification
};
